import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { IconSpinnerSolid } from '@circlefin/euclid-icons/common';
import classNames from 'classnames';
import { Tooltip } from '../Tooltip/Tooltip.es.js';

const IconButton = /*#__PURE__*/ forwardRef(({ children, appearance = 'primary', size = 'base', loading = false, label, disabled, className, type = 'button', onClick, ...props }, ref)=>{
    const classes = classNames('cb-icon-button', appearance, size, {
        loading
    }, className);
    return jsx(Tooltip, {
        className: "isolate",
        closeEvents: [
            'click',
            'mouseleave'
        ],
        content: label,
        place: "bottom",
        size: "sm",
        width: "hug",
        children: jsx("button", {
            ref: ref,
            "aria-label": label,
            className: classes,
            disabled: loading || disabled,
            onClick: onClick,
            type: type,
            ...props,
            children: loading ? jsx("div", {
                className: "spinner",
                children: jsx(IconSpinnerSolid, {
                    className: "animate-spin"
                })
            }) : jsx("span", {
                children: children
            })
        })
    });
});
IconButton.displayName = 'IconButton';

export { IconButton as default };
//# sourceMappingURL=IconButton.es.js.map
